import { Controller } from "@hotwired/stimulus"
import { isVisible } from "../utils"

const FOCUSABLE = [
  "a[href]",
  "button:not([disabled])",
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
].join(", ")

// Keeps Tab and Shift+Tab inside a kModal dialog, wrapping at either end.
// Listens on the document so focus that has fallen behind the modal is pulled back in.
export default class extends Controller {
  trapTab(event) {
    if (event.key !== "Tab" || !isVisible(this.element)) return

    const focusables = this.focusables()
    const first = focusables[0]
    const last = focusables[focusables.length - 1]
    const active = document.activeElement
    const focusInside = this.element.contains(active)

    if (!first) {
      event.preventDefault()
    } else if (event.shiftKey && (!focusInside || active === first)) {
      event.preventDefault()
      last.focus()
    } else if (!event.shiftKey && (!focusInside || active === last)) {
      event.preventDefault()
      first.focus()
    }
  }

  focusables() {
    return Array.from(this.element.querySelectorAll(FOCUSABLE)).filter(isVisible)
  }
}
